if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);

function swymCallbackFn(swat) {
  console.log("CallbackFn");

  $("#pageWrapper").css("visibility", "visible");

  function confirmDeleteModal(deleteCallback, lid) {
    modal = document.getElementById("deleteModal");
    modal.style.display = "block";

    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
    $("#delete-modal-cancel").click(function () {
      $("#deleteModal").css("display", "none");
    });
  }

  function showDiscount(id) {
    modal = document.getElementById("shareModal");
    modal.style.display = "block";

    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };

    let sendForm = document.getElementById("share-form");
    sendForm.addEventListener("submit", function handleSubmit(event) {
      event.preventDefault();
      let name = sendForm.elements["name"].value;
      let email = sendForm.elements["email"].value;
      let listId = id;

      modal.style.display = "none";

      generateShareLink(listId, name, email);
      sendForm.outerHTML = sendForm.outerHTML;
      sendForm.removeEventListener("submit", handleSubmit);
    });
  }

  // enables the sidebar ajax cart for new dom elements
  function initiateAjaxCart() {
    window.ajaxCart.init({
      formSelector: ".AddToCartForm",
      cartContainer: "#CartContainer",
      addToCartSelector: "#AddToCart",
      cartCountSelector: "#CartCount",
      moneyFormat: window.Currency
        ? window.Currency.moneyFormats[window.Currency.shopCurrency]
            .money_format
        : window.default_currency_format,
    });
  }

  function refreshLists() {
    var parent = document.getElementById("wishlist-lists-container");
    parent.replaceChildren();

    swat.fetchLists({
      callbackFn: function (lists) {
        if (lists.length == 0) {
          if (!$("#wishlist-empty")) {
            const emptyTextDiv = `<div id="wishlist-empty">
  						No items in your list.<br><br>

						Continue shopping or Log in to view your saved lists
						</div>`;

            $("wishlist-lists-container").append(emptyTextDiv);
          }
          $("#wishlist-empty").css("display", "block");
        }

        for (let i = 0; i < lists.length; i++) {
          swat.fetchListDetails(
            { lid: lists[i].lid },
            function (listContents) {
              if ($("#wishlist_container_" + lists[i].lid).length) {
                return;
              }

              let listID = listContents.list.lid;

              let container = $("#wishlist-lists-container");
              container.append(`<div id="wishlist_container_${lists[i].lid}" class="swym-entry img-responsive" animation-name: "fadeIn"><a id="wishlist-link" class="wishlist-link main-interactive"><p class="list-card-title"> ${listContents.list.lname}
                           </p><div id='wishlist-img-thumbnails' class='wishlist-img-thumbnails'></div><p id="list-card-items" class="list-card-items">0 ITEMS</p></a><div id="share-wishlist" class="share-icon"></div></div>`);

              $("#wishlist-img-thumbnails").attr(
                "id",
                "wishlist-img-thumbnails_" + listID
              );

              for (let i = 0; i < 2; i++) {
                if (!listContents.items[i]) {
                  break;
                }

                let product = listContents.items[i];

                // if product.iu exists in the data object prefer to use this
                if (product.iu) {
                  let productImage = product.iu;
                  const imgContainer = $("#wishlist-img-thumbnails_" + listID);
                  imgContainer.append(
                    `<img id='wishlist-thumbnail' src='${productImage}'>`
                  );
                }

                // if product.iu is undefined then get the image from the full product object instead
                else {
                  swat.getProductDetails(
                    { empi: product.empi, epi: product.epi, du: product.du },
                    function (productObject) {
                      let productImage = productObject.featured_image;
                      const imgContainer = $(
                        "#wishlist-img-thumbnails_" + listID
                      );
                      imgContainer.append(
                        `<img id='wishlist-thumbnail' src='${productImage}'>`
                      );
                    }
                  );
                }
              }

              $("#share-wishlist").attr("id", "share-wishlist_" + listID);
              $("#share-wishlist_" + listID).click(function () {
                showDiscount(listID);
              });

              $("#list-card-items").attr("id", "list-card-items_" + listID);
              document.getElementById("list-card-items_" + listID).textContent =
                listContents.items.length + " ITEMS";

              if (listContents.items.length == 1) {
                document.getElementById(
                  "list-card-items_" + listID
                ).textContent = listContents.items.length + " ITEM";
              }

              $("#wishlist-link").attr("id", "wishlist-link_" + listID);

              document
                .getElementById("wishlist-link_" + listID)
                .addEventListener("click", function () {
                  viewList(listContents.list);
                });
            },
            function (xhrObj) {
              console.log("Error fetching list details.");
            }
          );
        }
      },
      errorFn: function (xhrObj) {
        console.log("Error fetching lists.");
        console.log(xhrObj);
      },
    });
  }

  refreshLists();

  function generateShareLink(list, name, email) {
    swat.sendListViaEmail(
      {
        toEmailId: email,
        fromName: name,
        note: "Hey, check out these products!",
        lid: list,
        cprops: {},
      },
      function (r) {
        console.log("Email sent for list id " + list);
      },
      function (r) {
        console.log("Email failed!");
        console.log(r);
      }
    );
  }

  function viewAllLists() {
    document.getElementById("modal-delete").replaceChildren();
    document.getElementById("wishlist-lists-container").replaceChildren();
    document.getElementById("wishlist-lists-container").style.display = "flex";
    document.getElementById("wishlist-list-items-container").style.display =
      "none";
    document.getElementById("wishlist-list-items-container").replaceChildren();

    let modal = document.getElementById("deleteModal");
    modal.replaceWith(modal.cloneNode(true));

    refreshLists();
  }

  function deleteList(lid) {
    swat.deleteList(
      lid,
      function (deletedListObj) {
        swat.fetchLists({
          callbackFn: function (lists) {
            if (lists.length == 0) {
              if (!$("#wishlist-empty")) {
                const emptyTextDiv = `<div id="wishlist-empty">
  						No items in your list.<br><br>

						Continue shopping or Log in to view your saved lists
						</div>`;

                $("wishlist-lists-container").append(emptyTextDiv);
              }
              $("#wishlist-empty").css("display", "block");
            }
          },
        });

        viewAllLists();
      },
      function (xhrObject) {
        console.log(xhrObject);
      }
    );
  }

  function viewList(list) {
    const listTemplate = `<div id="wishlist_header_row_${list.lid}" class="wishlist-header-row">
    	<button id="wishlist-back">back</button>
      	<h3 class="wishlist-main-title" id="wishlist-main-title_${list.lid}"></h3>
    	<button id='wishlist-delete-list-button_${list.lid}' class="wishlist-delete-list-button">Delete List</button>
    
 		</div>
		<div id="wishlist-list-items-product-container_${list.lid}" class="wishlist-list-items-product-container" style="display: none; flex-wrap: wrap;">
		</div>`;

    const modalDelete = `<button id="delete-modal-delete_${list.lid}" class="delete-modal-delete modal-coupon modal-coupon-delete">DELETE</button>
							<button id="delete-modal-cancel" class="modal-coupon-cancel">CANCEL</button>`;

    $("#modal-delete").append(modalDelete);

    $("#delete-modal-delete_" + list.lid).click(function () {
      $("#deleteModal").css("display", "none");
      deleteList(list.lid);
    });

    const listContainer = document.getElementById("wishlist-lists-container");
    listContainer.style.display = "none";

    $("#wishlist-list-items-container").append(listTemplate);

    const back = document.getElementById("wishlist-back");
    back.addEventListener("click", viewAllLists);

    //
    document.getElementById("wishlist-add-list-button").style.display = "none";
    document.getElementById("wishlist-add-container").style.display = "none";
    document.getElementById("wishlist-list-items-container").style.display =
      "block";
    document.getElementById("wishlist-main-title_" + list.lid).textContent =
      list.lname;

    $("#wishlist-delete-list-button_" + list.lid).click(function () {
      confirmDeleteModal(deleteList, list.lid);
    });

    $("#wishlist-delete-list-button_" + list.lid).attr("listId", list.lid);

    var itemContainer = document.getElementById(
      "wishlist-list-items-product-container_" + list.lid
    );
    itemContainer.style.display = "flex";

    swat.fetchListDetails(
      list.lid,
      function (listContents) {
        var listSize = listContents.items.length;
        var loaded = 0;

        for (let i = 0; i < listContents.items.length; i++) {
          const product = listContents.items[i];

          const productCard = `<div id="grid-item_${product.epi}" class="grid__item large--one-quarter medium--one-half small--one-half" style="visibility: visible; animation-name: fadeIn;">
			<div id ="wishlist-item" class="grid-view-item"><div class="grid-view-item-image">
			<a id ="wishlist-item-details" href="${product.du}" title="${product.dt}" class="grid__image grid__image__match">
			<img id ="wishlist-item-image_${product.id}" src="${product.iu}" alt="${product.dt}" class="img-responsive" style="visibility: visible; animation-name: fadeIn; width: 100%;">
			</a>
	
			<div id="wishlist-cart-selector_${product.epi}" class="variants-options">

			</div> 
  			</div>
  			<button type="button" class="quick-shop-quickadd">
				<span class="quick-shop-quickadd__icon">+</span>
    			<span class="quick-shop-quickadd__text"> Quick Add</span>
 			 </button>
  			<div class="grid-view-item--desc-wrapper">
    			<div>


      			<div class="title-row" style="display: flex;">
      			<p class="product-grid--title">
        			<a href="${product.du}">${product.dt}</a>
				</p>
				<div style="position: relative; width:20px">
				<a id="wishlist-remove_${product.epi}"><i class="fa fa-heart fa-lg" style="position: relative; float: right;
					right: 7px; font-size:1em; line-height: 1.3;"></i></a>
      			</div>
      			</div>

      			<p class="product-grid--price">
      			</p>
			<div class="more-colours-collection">
  			<div class="more-colours-collection--wrapper">   
  			</div> 
 			</div>
    		</div>
  			</div>
  			</div>
			</div>`;

          $("#wishlist-list-items-product-container_" + list.lid).append(
            productCard
          );

          // if the product.iu was undefined, get the full product details and use this instead
          if (!product.iu) {
            swat.getProductDetails(
              { empi: product.empi, epi: product.epi, du: product.du },
              function (productObject) {
                $("#wishlist-item-image_" + product.id).attr(
                  "src",
                  productObject.featured_image
                );
              }
            );
          }

          let removeFromWishlist = function () {
            var listItemMap = {
              epi: product.epi, // unique epi per listid
              empi: product.empi,
              du: product.du,
            };

            swat.deleteFromList(
              list.lid,
              listItemMap,
              function (deletedListItem) {
                // successfully deleted list item
                //callback(deletedListItem);
              },
              function (xhrObj) {
                console.log("Error deleting item");
                console.log(xhrObj);
              }
            );

            $("#grid-item_" + product.epi).hide("slow", function () {
              $target.remove();
            });
          };

          $("#wishlist-remove_" + product.epi).click(removeFromWishlist);

          // add the cart quick selectors for each product. requires the full product object for variant information
          swat.getProductDetails(
            { empi: product.empi, epi: product.epi, du: product.du },
            function (productObject) {
              if (productObject.options?.length > 1) {
                //product has multiple options, deactivate quick selector
                let cartOption = `<div id="AddToCartForm"class="quick-add-to-cart clearfix AddToCartForm">
                                    <a tabindex="-1" href="/products/${productObject.handle}" style="display: block!important;" class="seeCartOptions">See Options</a>
                                  </div>`;
                $("#wishlist-cart-selector_" + product.epi).append(cartOption);
              } else {
                for (let i = 0; i < productObject.variants.length; i++) {
                  if (productObject.variants[i].available) {
                    const currentId = product.epi;

                    const cartOption = `<form id="AddToCartForm" action="/cart/add" method="post" enctype="multipart/form-data" class="quick-add-to-cart clearfix AddToCartForm">
          				<input type="hidden" name="id" value="${productObject.variants[i].id}">
          				<input data-ph-capture-attribute-product-name="${productObject.title}" data-ph-capture-attribute-page-type="Wishlist" type="submit" name="add" id="AddToCart" class="AddToCart" value="${productObject.variants[i].title}">
        				</form>`;

                    $("#wishlist-cart-selector_" + currentId).append(
                      cartOption
                    );
                  }
                }
              }

              loaded += 1;

              if (loaded == listSize) {
                // connects the sidebar cart to the cart selectors
                initiateAjaxCart();
              }
            },
            function (e) {}
          );
        }

        //for mobile quickadd
        $(".quick-shop-quickadd").on("click", function (e) {
          e.preventDefault();
          if ($(this).parent().hasClass("variants-options-on")) {
            $(".grid-view-item").removeClass("variants-options-on");
          } else {
            $(".grid-view-item").removeClass("variants-options-on");
            $(this).parent().addClass("variants-options-on");
          }
        });

        $("html,body").scrollTop(0);
      },
      function (xhrObj) {
        console.log("Error");
        console.log(xhrObj);
      }
    );
  }
}

var swym = document.getElementsByClassName("swym-wishlist-container-content");
for (let i = 0; i < swym.length; i++) {
  swym[i].style.display = "none";
}
